// Fill in the browser and dock URLs.
// Also disables clicking them because, in testing,
// it leads to confusing behavior. It copies the links instead.
(() => {
	const obsDockUrl = window.location.origin + "/dock/";
	const obsBrowserUrl = window.location.origin + "/browser/";

	document
		.querySelectorAll(".js-dock-url")
		.forEach(a => {
			a.innerHTML = obsDockUrl;
			a.href = obsDockUrl;
			a.setAttribute("title", `Copy ${obsDockUrl}`);
			a.addEventListener("click", (ev) => {
				ev.preventDefault();
				navigator.clipboard.writeText(obsDockUrl)
					.then(() => {
						a.innerHTML = "(Copied)";
						window.setTimeout(() => {
							a.innerHTML = obsDockUrl;
						}, 1500);
					});
			});
		});

	document
		.querySelectorAll(".js-browser-url")
		.forEach(a => {
			a.innerHTML = obsBrowserUrl;
			a.href = obsBrowserUrl;
			a.setAttribute("title", `Copy ${obsBrowserUrl}`);
			a.addEventListener("click", (ev) => {
				ev.preventDefault();
				navigator.clipboard.writeText(obsBrowserUrl)
					.then(() => {
						a.innerHTML = "(Copied)";
						window.setTimeout(() => {
							a.innerHTML = obsBrowserUrl;
						}, 1500);
					});
			});
		});
})();

// Swiper slideshow library setup (browser source).
(() => {
	new Swiper('.browser-slideshow', {
		// Optional parameters
		direction: 'horizontal',

		// Navigation arrows
		navigation: {
			nextEl: '.browser-slideshow .swiper-button-next',
			prevEl: '.browser-slideshow .swiper-button-prev',
		},

		pagination: {
			el: ".browser-slideshow .swiper-pagination",
			clickable: true,
		},
	});
})();

// Swiper slideshow library setup (dock).
(() => {
	new Swiper(".dock-slideshow", {
		direction: "horizontal",

		navigation: {
			nextEl: ".dock-slideshow .swiper-button-next",
			prevEl: ".dock-slideshow .swiper-button-prev",
		},

		pagination: {
			el: ".dock-slideshow .swiper-pagination",
			clickable: true,
		},
	});
})();